export default __webpack_public_path__ + "static/media/insert-drive-file.392d7f95.svg";